var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCheckCircle68Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_261_671)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 34C0 15.2223 15.2223 0 34 0C52.7777 0 68 15.2223 68 34C68 52.7777 52.7777 68 34 68C15.2223 68 0 52.7777 0 34Z",
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 17C24.616 17 17 24.616 17 34C17 43.384 24.616 51 34 51C43.384 51 51 43.384 51 34C51 24.616 43.384 17 34 17ZM34 47.6C26.503 47.6 20.4 41.497 20.4 34C20.4 26.503 26.503 20.4 34 20.4C41.497 20.4 47.6 26.503 47.6 34C47.6 41.497 41.497 47.6 34 47.6ZM41.803 26.486L30.6 37.689L26.197 33.303L23.8 35.7L30.6 42.5L44.2 28.9L41.803 26.486Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_261_671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckCircle68Px);
export default __webpack_public_path__ + "static/media/ic_check_circle_68px.98b118d6897066b54589275cf79ace6d.svg";
export { ForwardRef as ReactComponent };